<div class="dashboard-cards-container">
	<ng-container *ngIf="!isEmpty; else emptyState">
		<div class="dashboard-card"
			 *ngFor="let card of cards"
			 [class.dashboard-card--expanded]="card.isExpanded"
			 [class.dashboard-card--clickable]="cardLayout.detailPanelName || cardLayout.isCardClickable"
			 [class.dashboard-card--selected]="isSelected(card)"
			 (click)="onCardClicked(card)">

			<div class="dashboard-card__body">
				<div class="dashboard-card__content">
					<div class="dashboard-card__title" *ngIf="card.titleField">
						{{ card.titleField.value }}
					</div>

					<div class="dashboard-card__subtitle" *ngIf="card.subtitleField">
						{{ card.subtitleField.value }}
					</div>

					<div class="dashboard-card__tags" *ngIf="card.tagFields.length > 0">
						<span class="dashboard-card__tag" *ngFor="let tag of card.tagFields">
							<i *ngIf="tag.icon" class="{{ tag.icon }} dashboard-card__tag-icon"></i>
							<span class="dashboard-card__tag-value">{{ tag.value }}</span>
						</span>
					</div>
				</div>

				<div class="dashboard-card__actions" *ngIf="actions.length > 0 || cardLayout.isExpandable">
					<button *ngFor="let action of actions"
							class="dashboard-card__action-btn"
							[class.dashboard-card__action-btn--danger]="action.name === 'delete'"
							[title]="action.label"
							(click)="onActionClicked(card, action, $event)">
						<i class="{{ getActionIcon(action.icon) }}"></i>
					</button>
					<button *ngIf="cardLayout.isExpandable"
							class="dashboard-card__action-btn dashboard-card__expand-btn"
							(click)="toggleExpand(card, $event)">
						<i class="mdi"
						   [class.mdi-chevron-down]="!card.isExpanded"
						   [class.mdi-chevron-up]="card.isExpanded"></i>
					</button>
				</div>
			</div>

			<div class="dashboard-card__details"
				 *ngIf="cardLayout.isExpandable && card.isExpanded && card.detailFields.length > 0">
				<div class="dashboard-card__detail-row" *ngFor="let detail of card.detailFields">
					<span class="dashboard-card__detail-label">{{ detail.annotation.label }}</span>
					<span class="dashboard-card__detail-value">{{ detail.value }}</span>
				</div>
			</div>
		</div>
	</ng-container>

	<ng-template #emptyState>
		<div class="dashboard-cards-empty">
			No data found...
		</div>
	</ng-template>
</div>
